export enum SystemPageType {
  ADDRESSES = 'Addresses',
  REGISTRATION_NUMBERS = 'Registration Numbers',
  ORDER_OVERVIEW = 'Order Overview',
  ORDER_DETAIL = 'Order Detail',
  SHIPMENT = 'Shipment',
  CALL_OFF_ORDER_DETAIL = 'Call Off Order Detail',
  INVOICES = 'Invoices',
  VAT_NUMBERS = 'Vat Numbers',
  MY_PRODUCTS_AND_PRICES = 'My Products and Prices',
  QUOTE_DETAIL = 'Quote Detail',
  SHOPPING_CART = 'Shopping Cart',
  CHECKOUT = 'Checkout',
  PORTAL_USERS = 'Portal Users',
  COMPANY_INFO = 'Company Info',
  PRODUCT_COMPARE = 'Product Compare',
  LIMITED_PRODUCT_DETAIL = 'Limited Product Detail'
}
